module.exports = __webpack_public_path__ + "static/media/quick-search.9eec0954.svg";